import axios from "axios";

const client = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL
});

export const GetPrograms = (token: string) => {
    return client.get('programs?Type=Marketing', { headers: {"Authorization" : `Bearer ${token}`}});
}